module.exports = __webpack_public_path__ + "img/package_bg_2.40b0b5bb.png";